import React from "react";

const Footer = () => {
  return (
    <>
      <div className="footer">
        <div className="card icard">
          <div className="row">
            <div className="col-lg-6">
              <div className="copyright company">
                <p style={{ fontSize: "15px" }}>
                  Copyright © 2026. Iraaya World. All Rights Reserved.
                </p>
              </div>
            </div>

            {/* <div className="col-lg-6">
              <div className="copyright inno">
                <a
                  href="https://www.innoblitz.global/"
                  style={{ color: "#CF2030", fontSize: "15px" }}
                  target="_blank"
                >
                  Design & Developed By Innoblitz Technologies And Systems Pvt
                  Ltd{" "}
                </a>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
